module.exports = __webpack_public_path__ + "static/media/custom-ex-16.8121ee2d.jpg";